import React from "react"
import hashtagLogo from "../Icons/hashtagLogo.svg"
import selectSocialIcon from "../Icons/selectSocialIcon"
import CuratorWidget from "./CuratorWidget"
import "./index.scss"

export default function CuratorSection({ component }) {
  const { socialMediaInfo, curatorFeedId } = component
  return (
    <section id="curator-section">
      <div className="container">
        <div className="row justify-content-center text-center">
          <div className="col">
            <img src={hashtagLogo} class="logo" alt="logo" />
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div id="curator-feed-default-feed-layout">
              <CuratorWidget curatorFeedId={curatorFeedId} />
            </div>
          </div>
        </div>
        <div className="row text-center mt-5">
          <div className="col">
            <h4 className="oblique highlight red">Follow PowerSwitch Action</h4>
          </div>
        </div>
        <div className="row text-center">
          <div className="col">
            <div className="social-media">
              {socialMediaInfo[0]?.socialMediaItem?.map(media => (
                <a
                  key={media.socialMediaLink}
                  className="social-media__link social-media__link--footer"
                  href={media.socialMediaLink}
                  target="_blank"
                  rel="noreferrer"
                >
                  {selectSocialIcon(media.socialMediaId, "#1F1646")}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
